import { render } from "./CustomNavbar.vue?vue&type=template&id=5007f868&scoped=true"
import script from "./CustomNavbar.vue?vue&type=script&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&lang=js"

import "./CustomNavbar.vue?vue&type=style&index=0&id=5007f868&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5007f868"]])

export default __exports__